import React, { useState, useEffect, useRef } from 'react';
import { TextField, InputAdornment, styled, Icon, IconButton } from '@mui/material';
import { LoginValidation } from './Login';
import { Person, Visibility, VisibilityOff } from '@mui/icons-material';

type LoginFormProps = {
  username: string;
  password: string;
  setUsername(username: string): void;
  setPassword(password: string): void;
  validation: LoginValidation;
};

const LoginForm: React.FC<LoginFormProps> = ({ username, password, setUsername, setPassword, validation }) => {
  const [passVisibility, setPassVisibility] = useState(true);
  const inputs = {
    username: useRef<HTMLInputElement>(null),
    password: useRef<HTMLInputElement>(null),
  };

  useEffect(() => {
    const [key] = Object.keys(validation) as [keyof typeof inputs];

    if (!key) return;

    inputs[key].current?.focus();
  }, [validation]); // eslint-disable-line

  function handlePasswordVisibility() {
    setPassVisibility(!passVisibility);
  }

  return (
    <>
      <TextField
        inputRef={inputs.username}
        error={!!validation.username}
        helperText={validation.username}
        label="Nome de usuário ou e-mail"
        placeholder="Seu nome de usuário ou e-mail"
        margin="normal"
        onChange={e => setUsername(e.target.value)}
        value={username}
        autoComplete="username"
        autoFocus
        slotProps={{
          input: {
            endAdornment: (
              <Icon>
                <Person color="primary" />
              </Icon>
            ),
          },
        }}
      />
      <TextField
        inputRef={inputs.password}
        error={!!validation.password}
        helperText={validation.password}
        label="Senha"
        placeholder="Sua senha"
        margin="normal"
        onChange={e => setPassword(e.target.value)}
        value={password}
        type={passVisibility ? 'password' : 'text'}
        autoComplete="current-password"
        slotProps={{
          input: {
            endAdornment: (
              <IconButton>
                {passVisibility ? (
                  <Visibility onClick={handlePasswordVisibility} color="primary" />
                ) : (
                  <VisibilityOff onClick={handlePasswordVisibility} color="primary" />
                )}
              </IconButton>
            ),
          },
        }}
      />
      <button type="submit" style={{ display: 'none' }} />
    </>
  );
};

export default LoginForm;
